import React from "react";
import ClaimVitalSignRequest from "./ClaimVitalSignRequest";
import ClaimDiagnosisRequest from "./ClaimDiagnosisRequest";
import MedicalInformationRequest from "./MedicalInformationRequest";
import { useSelector } from "react-redux";
import { Row } from "react-bootstrap";

const DiagnosisVitalMedicalDetails = () => {
  const { viewClaimInfo, stepFormData, claimRequestData } = useSelector(
    (state) => state.claim
  );
  const payloadClaim = viewClaimInfo?.payload_json;
  const claimType =
    stepFormData?.claim_type?.claim_types_code || viewClaimInfo?.claim_type;
  const prescription =
    stepFormData?.prescription ||
    payloadClaim?.prescript_submt ||
    claimRequestData?.entry?.find(
      (item) => item?.resource?.resourceType === "Claim"
    )?.resource?.use === "predetermination";
  return (
    <Row className="d-flex flex-column border border-info rounded gap-3">
      {claimType !== "vision" && <ClaimVitalSignRequest />}
      <ClaimDiagnosisRequest />
      {!prescription && <MedicalInformationRequest />}
    </Row>
  );
};

export default DiagnosisVitalMedicalDetails;
